export const isHex = (v: string) => /^#[0-9a-fA-F]{6}$/.test(v);

function channel(c: number) {
  const s = c / 255;
  return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
}

export function luminance(hex: string) {
  const n = parseInt(hex.slice(1), 16);
  return 0.2126 * channel((n >> 16) & 255) + 0.7152 * channel((n >> 8) & 255) + 0.0722 * channel(n & 255);
}

/** WCAG contrast ratio between two #rrggbb colours (1–21). */
export function contrast(a: string, b: string) {
  const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (hi + 0.05) / (lo + 0.05);
}

/** Fonts a merchant may choose. Anything else is rejected so a bad value can never break the storefront. */
export const FONT_OPTIONS = ['Inter', 'Poppins', 'DM Sans', 'Manrope', 'Nunito'] as const;
export const RADIUS_OPTIONS = [
  { value: '0.25rem', label: 'Sharp' }, { value: '0.5rem', label: 'Subtle' }, { value: '0.75rem', label: 'Rounded (default)' },
  { value: '1rem', label: 'Soft' }, { value: '1.25rem', label: 'Pill-like' },
];
